"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConduitController__factory = exports.Conduit__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var Conduit__factory_1 = require("./Conduit__factory");
Object.defineProperty(exports, "Conduit__factory", { enumerable: true, get: function () { return Conduit__factory_1.Conduit__factory; } });
var ConduitController__factory_1 = require("./ConduitController__factory");
Object.defineProperty(exports, "ConduitController__factory", { enumerable: true, get: function () { return ConduitController__factory_1.ConduitController__factory; } });
//# sourceMappingURL=index.js.map